// assets/js/numbers-gsap.js
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export function numbersCounter() {
  document.addEventListener("DOMContentLoaded", () => {
    gsap.registerPlugin(ScrollTrigger);

    const items = Array.from(document.querySelectorAll(".js-animate-number"));
    if (!items.length) return;

    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    items.forEach((el) => {
      const target = parseFloat(el.getAttribute("data-number") || "0") || 0;

      if (reduce) {
        el.textContent = `${Math.round(target)}%`;
        return;
      }

      // stato iniziale per fade-in
      gsap.set(el, { opacity: 0, y: 12 });

      const obj = { val: 0 };

      gsap
        .timeline({
          scrollTrigger: {
            trigger: el,
            start: "top 80%",
            toggleActions: "play none none none",
            once: true,
          },
        })
        .to(el, {
          opacity: 1,
          y: 0,
          duration: 0.35,
          ease: "power2.out",
        })
        .to(
          obj,
          {
            val: target,
            duration: 1.2,
            ease: "power2.out",
            onUpdate: () => {
              el.textContent = `${Math.round(obj.val)}%`;
            },
            onComplete: () => {
              el.textContent = `${Math.round(target)}%`;
            },
          },
          "-=0.05"
        );
    });
  });
}